export default {"src":"/_next/static/media/WETH.2c3aabf7.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};